import { createApp } from 'vue'
import { getPluginConfig } from './config.js'
import { createApi } from './api.js'
import { createStore } from './store.js'
import App from './App.vue'

function init() {
  const config = getPluginConfig()
  if (!config) return

  const { apiBaseUrl, gommistaId, container, staticBaseUrl = '' } = config
  const api = createApi(apiBaseUrl)
  const store = createStore(gommistaId)

  const el = document.querySelector(container)
  if (!el) {
    console.error('[Plugin Cambio Gomme] Container non trovato:', container)
    return
  }

  const app = createApp(App, { store, api, staticBaseUrl })
  app.mount(el)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
